<template>
  <v-layout row wrap class="mx-0 mt-3 auditoriaMain">
    <v-flex xs12>
      <v-data-table
        ref="dataTable"
        item-key="permiso"
        class="auditoriaMain dataTable"
        sort-by="revision"
        :sort-desc.sync="view.elem.datatable.sortdesc"
        :headers="view.elem.datatable.headers"
        :items="view.elem.datatable.data"
        :search="view.elem.datatable.search"
        :must-sort="true"
        :options.sync="options">
        <template #item.revisionDate="{ item }">
          {{ formatDate(item.revisionDate) }}
        </template>
        <template #item.accion="{ item }">
          <buttonCustom
            :ref="`dataTableBtnAuditDetail_${item.clave}`"
            :paramtype="'Object'"
            :paramobj="item"
            action="detail"
            icon="fas fa-search"
            :title="$t('view.auditoria.main.detail')"
            @detail="detail" />
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import AuditoriaAPI from "@/services/auditoria"; /** *******************************/
import ButtonCustom from "@/components/datatable/ButtonCustom"; /** *******************************/
import { formatDate } from "@/helpers/date-methods";
import tippy from "tippy.js";

export default {
  name: "AuditoriaMainTable"
  , components: { ButtonCustom }
  , data() {
    return {
      options: {}
      , changes: []
      , view: {
        elem: {
          datatable: {
            data: []
            , search: ""
            , sortdesc: true
            , headers: [
              { text: this.$t("view.auditoria.main.revision.th"), align: "center", sortable: true, class: "revision", value: "revision" }
              , { text: this.$t("view.auditoria.main.usuario.th"), align: "center", sortable: true, class: "user", value: "user" }
              , { text: this.$t("view.auditoria.main.fecha.th"), align: "center", sortable: true, class: "revisionDate", value: "revisionDate" }
              , { text: this.$t("view.auditoria.main.hora.th"), align: "center", sortable: true, class: "revisionTime", value: "revisionTime" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    async load() {
      this.view.elem.datatable.data = this.changes;
      this.view.elem.datatable.total = Number(this.changes.length);
    }
    , async loadChanges(clave, tabla, descripcion) {
      const respuesta = await AuditoriaAPI.get({ clave, tabla, descripcion });
      this.changes = respuesta.data.results.lista;
      this.view.elem.datatable.search = "";
      this.view.elem.datatable.sortdesc = true;
      this.load();
    }
    , async detail(item) {
      this.$emit("detail", item.revision);
    }
    , formatDate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auditoria/AuditoriaMainTable.vue